var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a;
import { appColors } from '@styled/useTheme';
import { EditorState, Modifier } from 'draft-js';
export var CustomTextSizeStyle;
(function (CustomTextSizeStyle) {
    CustomTextSizeStyle["SIZE_10"] = "SIZE_10";
    CustomTextSizeStyle["SIZE_12"] = "SIZE_12";
    CustomTextSizeStyle["SIZE_14"] = "SIZE_14";
    CustomTextSizeStyle["SIZE_18"] = "SIZE_18";
})(CustomTextSizeStyle || (CustomTextSizeStyle = {}));
var fontStyles = [
    CustomTextSizeStyle.SIZE_10,
    CustomTextSizeStyle.SIZE_12,
    CustomTextSizeStyle.SIZE_14,
    CustomTextSizeStyle.SIZE_18,
];
export var CustomTextColorStyle;
(function (CustomTextColorStyle) {
    CustomTextColorStyle["COLOR_UI"] = "COLOR_UI";
    CustomTextColorStyle["COLOR_PRIMARY"] = "COLOR_PRIMARY";
    CustomTextColorStyle["COLOR_ERROR"] = "COLOR_ERROR";
    CustomTextColorStyle["COLOR_NEUTRAL"] = "COLOR_NEUTRAL";
})(CustomTextColorStyle || (CustomTextColorStyle = {}));
export var colorStyles = [
    CustomTextColorStyle.COLOR_UI,
    CustomTextColorStyle.COLOR_PRIMARY,
    CustomTextColorStyle.COLOR_ERROR,
    CustomTextColorStyle.COLOR_NEUTRAL,
];
export var customTextStyles = (_a = {
        STRIKETHROUGH: { textDecoration: 'line-through' }
    },
    _a[CustomTextSizeStyle.SIZE_10] = { fontSize: 10 },
    _a[CustomTextSizeStyle.SIZE_12] = { fontSize: 12 },
    _a[CustomTextSizeStyle.SIZE_14] = { fontSize: 14 },
    _a[CustomTextSizeStyle.SIZE_18] = { fontSize: 18 },
    _a[CustomTextColorStyle.COLOR_UI] = { color: appColors.ui.dark },
    _a[CustomTextColorStyle.COLOR_PRIMARY] = { color: appColors.primary.w500 },
    _a[CustomTextColorStyle.COLOR_ERROR] = { color: appColors.error.w500 },
    _a[CustomTextColorStyle.COLOR_NEUTRAL] = { color: appColors.neutral.w700 },
    _a);
export function changeFontStyle(editorState, sizeStyle) {
    var e_1, _a;
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    try {
        for (var fontStyles_1 = __values(fontStyles), fontStyles_1_1 = fontStyles_1.next(); !fontStyles_1_1.done; fontStyles_1_1 = fontStyles_1.next()) {
            var fontStyle = fontStyles_1_1.value;
            contentState = Modifier.removeInlineStyle(contentState, selectionState, fontStyle);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (fontStyles_1_1 && !fontStyles_1_1.done && (_a = fontStyles_1.return)) _a.call(fontStyles_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    contentState = Modifier.applyInlineStyle(contentState, selectionState, sizeStyle);
    var newState = EditorState.push(editorState, contentState, 'change-inline-style');
    return newState;
}
export function changeColorStyle(editorState, colorStyle) {
    var e_2, _a;
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    try {
        for (var colorStyles_1 = __values(colorStyles), colorStyles_1_1 = colorStyles_1.next(); !colorStyles_1_1.done; colorStyles_1_1 = colorStyles_1.next()) {
            var colorStyle_1 = colorStyles_1_1.value;
            contentState = Modifier.removeInlineStyle(contentState, selectionState, colorStyle_1);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (colorStyles_1_1 && !colorStyles_1_1.done && (_a = colorStyles_1.return)) _a.call(colorStyles_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    contentState = Modifier.applyInlineStyle(contentState, selectionState, colorStyle);
    var newState = EditorState.push(editorState, contentState, 'change-inline-style');
    return newState;
}
